module.exports = __webpack_public_path__ + "img/sub_equipment.77d99e1c.png";